import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormattedMessageV2 } from '@/views/components/i18n';
import { Tooltip } from '@/views/components/tooltips';

// Utils
import { formatMessage } from '@/utils/i18n';

// Constants
const i18nBasePath = 'PortfolioEditorBuilder.Footer';

type Props = {
  isSaving: boolean;
  isSaveDisabled: boolean;
  onSave: () => Promise<void>;
};

const PortfolioEditorFooterActions = ({ isSaving, isSaveDisabled, onSave }: Props) => (
  <div className="portfolio-editor-footer-actions">
    <Tooltip className="custom-tooltip-v2" disabled={!isSaving} message={formatMessage(`${i18nBasePath}.SavingChanges`)}>
      <div className="tooltip-wrapper">
        <Button variant="primary" disabled={isSaveDisabled} loading={isSaving} onClick={onSave} data-testid="portfolioEditorFooter-primaryButton-savePortfolio">
          <FormattedMessageV2 toLocalize={`${i18nBasePath}.${isSaving ? 'Saving' : 'SavePortfolio'}`} />
        </Button>
      </div>
    </Tooltip>
  </div>
);

export default PortfolioEditorFooterActions;
